<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar @click-left="onClickLeft" left-arrow :safe-area-inset-top="true" :title="richText.name" />
    </van-sticky>
    <div class="pl40 pr40 pb40">
      <div class="rich-text" v-html="richText.content">
    </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { fetchByCode } from '../../../api/rich-text'
export default {
  data() {
    return {
      code: '',
      richText: {}
    };
  },
  components: {
  },
  created() {
    this.init()
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    onClickLeft() {
      history.back()
    },
    init() {
      this.code = this.$route.query.code
      if (this.code) {
        fetchByCode(this.code).then(res => {
          this.richText = res
        })
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../../assets/css/style.css');
.rich-text {
  border-radius: 16px;
  margin-top: 40px;
  background: #fff;
  font-size: 0.38rem;
  padding: 40px;
}
</style>